import {
    addExportBtns,
    addSelectedCompanyHandler, fnToastrFormError, getSelectedCompany,
    printResponse
} from "../jquery-functions-library";
import {element_exists, redesignDataTablesHeader} from "../functions";

export var fnBiCompaniesTable = function () {

    if (!element_exists('#datatable-bi-companies')) return false;
    drawTable();

    addSelectedCompanyHandler(drawTable);

};

function drawTable() {

    var tableName = '#datatable-bi-companies';
    var modal = $('#modal-edit-bi-companies');
    var selectedCompanyId = getSelectedCompany();
    $('#company_id_input').val(selectedCompanyId);

    if (selectedCompanyId == 'default') {
        $('#create-bi-reporting-btn').hide();
        $('#file-import-column').hide();
    } else {
        $('#create-bi-reporting-btn').show();
        $('#file-import-column').show();
    }

    $('#create-bi-reporting-btn').off('click', modal).on('click', modal, function () {
        $('.empty_it').val('');
        $('#delete_bi_entry').addClass('hidden');
        modal.modal('show');
    });

    $('#upload-bi-column-imports-btn').off('click').on('click', function () {
        $('#file-bi-col-imports-btn').trigger('click');
    });

    $('#file-bi-col-imports-btn').off('change').on('change', function () {
        // select the form and submit
        $('#file-bi-col-imports-form').submit();
    });

    function modifyUrlToAdminOrClient(url, selectedCompanyId) {
        if (selectedCompanyId) {
            url += '/' + selectedCompanyId;
        }
        return url;
    }

    $('#file-bi-col-imports-form').off('submit').on('submit', function (e) {
        e.preventDefault();

        var formData = new FormData($(this)[0]);
        var url = modifyUrlToAdminOrClient(this.action, selectedCompanyId);

        $.ajax({
            type: 'POST',
            url: url,
            data: formData,
            success: function (response) {
                printResponse(response);
                $(tableName).DataTable().ajax.reload(null, false);
                $('#file-bi-col-imports-btn').val('');
            },
            error: function (data) {
                var errors = '';
                for (var datos in data.responseJSON.errors) {
                    console.log(datos);
                    errors += data.responseJSON.errors[datos] + '<br>';
                }
                toastr.error(errors);
                $('#file-bi-col-imports-btn').val('');
            },
            cache: false,
            processData: false,
            contentType: false,
        });

    });

    $('#form-edit-bi-companies').off('submit').on('submit', function (e) {
        e.preventDefault();

        var formData = $('#form-edit-bi-companies').serialize();
        var url = modifyUrlToAdminOrClient('saveBiRow', selectedCompanyId);

        $.ajax({
            type: 'POST',
            url: url,
            data: formData,
            success: function (response) {
                $(tableName).DataTable().ajax.reload(null, false);
                $('.empty_it').val('');
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });

    $('#delete_bi_entry').off('click').on('click', function (e) {
        e.preventDefault();

        var formData = $('#form-edit-bi-companies').serialize();

        var url = modifyUrlToAdminOrClient('deleteBiRow', selectedCompanyId);
        $.ajax({
            type: 'POST',
            url: url,
            data: formData,
            success: function (response) {
                $(tableName).DataTable().ajax.reload(null, false);
                $('.empty_it').val('');
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });

    $('#datatable-bi-companies tbody').off('click', 'tr');
    $('#datatable-bi-companies tbody').on('click', 'tr', function () {

        var tableData = table.row(this).data();

        var url = modifyUrlToAdminOrClient('/getBiRow', selectedCompanyId);

        console.log(url);

        $.ajax({
            type: 'POST',
            url: url,
            data: {
                bi_id: tableData.id,
            },
            success: function (response) {
                $('#bi_id').val(response[0].id);
                $('#reporting_account').val(response[0].reporting_account);
                $('#reporting_account_nr').val(response[0].reporting_account_nr);
                $('#account_mapping').val(response[0].accounts_in_mapping);
                $('#measurement_calculation').val(response[0].measurement_calculation);
            },
            error: fnToastrFormError,
        });
        $('#delete_bi_entry').removeClass('hidden');
        modal.modal('show');
    });

    modal.on('shown.bs.modal', function () {
        $('#reporting_account').focus();
    });

    var columns = [
        {data: 'id'},
        {data: 'reporting_account'},
        {data: 'reporting_account_nr'},
        {data: 'accounts_in_mapping_text'},
        {data: 'measurement_calculation'},
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {className: "p-l-10", width: "25%", targets: 0},
        {className: "p-l-10", width: "25%", targets: 1},
        {className: "p-l-10", width: "25%", targets: 2},
        {className: "p-l-10", width: "25%", targets: 3},
        {className: "p-l-10", width: "25%", targets: 4},
    ];

    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');

    var urlTableData = modifyUrlToAdminOrClient('/getBiDataCompany', selectedCompanyId);
    console.log(urlTableData);
    var table = $(tableName).DataTable({
        language: allLangFiles.datatables,
        ajax: {
            url: urlTableData,
        },
        columns: columns,
        columnDefs: columnDefs,
        destroy: true,
        scrollX: true,
        lengthMenu: [10, 25, 50, 75, 100],
        initComplete: function (settings, json) {
            table.draw();
        },
    });
    addExportBtns($(tableName));
    const { $filterButtons } = redesignDataTablesHeader(tableName, true, null, false);
    // $filterButtons.prepend($('#create-bi-reporting-btn'));
}